export var GLEAM_STATUS_TYPES = Object.freeze({
  DEFAULT: 'default',
  INFO: 'info',
  NEW: 'new'
});